import { tarifaPaletsService } from "@/_services";
export const tarifaPalet = {
  namespaced: true,
  state: {
    list: {
      data: [],
      status: {},
    },
    entity: {
      data: [],
      status: {},
    },
    delete: {
      data: [],
      status: {},
    },
    update: {
      data: [],
      status: {},
    },
    post: {
      data: [],
      status: {},
    },
  },
  mutations: {
    getTarifasPaletsRequest(state) {
      state.list.status = {
        loading: true,
      };
    },
    getTarifasPaletsSuccess(state, response) {
      state.list.data = response;
      state.list.status = {
        loaded: true,
      };
    },
    getTarifasPaletsError(state, error) {
      state.list.data = null;
      state.list.status = {
        error,
      };
    },
    deleteTarifaPaletRequest(state) {
      state.delete.status = {
        deleting: true,
      };
    },
    deleteTarifaPaletError(state, error) {
      state.delete.data = null;
      state.delete.status = {
        error,
      };
    },
    deleteTarifaPaletSuccess(state, response) {
      state.delete.data = response;
      state.delete.status = {
        deleted: true,
      };
    },
    postTarifaPaletRequest(state) {
      state.post.status = {
        creating: true,
      };
    },
    postTarifaPaletError(state, error) {
      state.post.data = null;
      state.post.status = {
        error,
      };
    },
    postTarifaPaletSuccess(state, response) {
      state.post.data = response;
      state.post.status = {
        created: true,
      };
    },
    updateTarifaPaletRequest(state) {
      state.update.status = {
        updating: true,
      };
    },
    updateTarifaPaletError(state, error) {
      state.update.data = null;
      state.update.status = {
        error,
      };
    },
    updateTarifaPaletSuccess(state, response) {
      state.update.data = response;
      state.update.status = {
        updated: true,
      };
    },
    getTarifaPaletByIdRequest(state) {
      state.entity.status = {
        loading: true,
      };
    },
    getTarifaPaletByIdError(state, error) {
      state.entity.data = null;
      state.entity.status = {
        error,
      };
    },
    getTarifaPaletByIdSuccess(state, response) {
      state.entity.data = response;
      state.entity.status = {
        loaded: true,
      };
    },
  },
  actions: {
    getTarifasPalets({ commit }, request) {
      commit("getTarifasPaletsRequest");
      tarifaPaletsService
        .getTarifasPalets(request.pagination, request.query)
        .then((response) => {
          commit("getTarifasPaletsSuccess", response);
        })
        .catch((error) => {
          commit("getTarifasPaletsError", error);
        });
    },
    deleteTarifaPalet({ commit }, id) {
      commit("deleteTarifaPaletRequest");
      tarifaPaletsService
        .deleteTarifaPalet(id)
        .then((res) => {
          commit("deleteTarifaPaletSuccess", res);
        })
        .catch((error) => {
          commit("deleteTarifaPaletError", error);
        });
    },
    postTarifaPalet({ commit }, request) {
      commit("postTarifaPaletRequest");
      tarifaPaletsService
        .postTarifaPalet(request)
        .then((res) => {
          commit("postTarifaPaletSuccess", res);
        })
        .catch((error) => {
          commit("postTarifaPaletError", error);
        });
    },
    updateTarifaPalet({ commit }, request) {
      commit("updateTarifaPaletRequest");
      tarifaPaletsService
        .updateTarifaPalet(request.id, request.body)
        .then((res) => {
          commit("updateTarifaPaletSuccess", res);
        })
        .catch((error) => {
          commit("updateTarifaPaletError", error);
        });
    },
    getTarifaPaletById({ commit }, id) {
      commit("getTarifaPaletByIdRequest");
      tarifaPaletsService
        .getTarifaPaletById(id)
        .then((res) => {
          commit("getTarifaPaletByIdSuccess", res);
        })
        .catch((error) => {
          commit("getTarifaPaletByIdError", error);
        });
    },
  },
};
